<template>
  <div data-scroll-name="gallery">
    <section class="my-20 bg-[#F3F5FB] py-10">
      <Container>
        <SectionHeader className="mt-0! mb-10!">Gallery</SectionHeader>
        
        <Carousel
          :items="getAllPhotos"
          @onSelectItem="selectPhoto"
          @onSlideChange="slideChange"
        />

        <div class="text-center mt-12">
          <button
            @click="selectPhoto(photoIndex)"
            class="py-2 px-6 cursor-pointer border-2 bg-transparent"
            :class="{
              'border-[var(--bg-primary-color)] text-primary-color': !getPrimaryColor,
              [`border-[${getPrimaryColor}] text-[${getPrimaryColor}]`]: getPrimaryColor
            }"
          >
            View Full Screen <FontAwesomeIcon icon="eye" class="ml-2" />
          </button>
        </div>
      </Container>

      <HMTLightbox
        :show="isLightbox"
        :index="photoIndex"
        :items="getAllPhotos"
        @onClose="toggleLightbox"
      />
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import HMTLightbox from '@/shared/components/Lightbox';
  import gaMixin from '@/shared/mixins/ga';
  import deviceMixin from '@/shared/mixins/device';
  import Container from '../../components/Container';
  import Carousel from './components/Carousel';

  export default {
    name: 'Gallery',
    mixins: [
      gaMixin,
      deviceMixin
    ],
    components: {
      SectionHeader,
      HMTLightbox,
      Container,
      Carousel
    },
    data () {
      return {
        photoIndex: 0,
        isLightbox: false
      }
    },
    computed: {
      ...mapGetters('tour', ['getAllPhotos', 'getPrimaryColor']),
      photos () {
        return this.getAllPhotos;
      }
    },
    methods: {
      selectPhoto (photoIndex) {
        this.photoIndex = photoIndex;

        this.toggleLightbox();
        this.sendEventGA('Gallery', `Image ${photoIndex + 1}`, 'Selected');
      },
      slideChange (activeIndex) {
        this.photoIndex = activeIndex;
      },
      toggleLightbox () {
        this.isLightbox = !this.isLightbox;
      }
    }
  };
</script>
